module.exports = __webpack_public_path__ + "img/logo-2.1944d0fb.webp";